import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';

import {
  TEAM_ADMIN_TRANSACTION_RECONCILIATION_FLAG,
} from '../../services/managed-feature-flags/managed-feature-flag-keys';
import { ManagedFeatureFlagsService } from '../../services/managed-feature-flags/managed-feature-flags.service';
import { SessionService } from '../../services/session/session.service';

@Injectable({
  providedIn: 'root',
})
export class TransactionReconciliationGuard {
  private activeEvaluationIdentity?: object;

  constructor(
    private managedFeatureFlagsService: ManagedFeatureFlagsService,
    private sessionService: SessionService,
    private router: Router,
  ) {}

  async canActivateChild(route: ActivatedRouteSnapshot): Promise<boolean | UrlTree> {
    const userId = this.sessionService.getUserId();
    const sessionIdentity = this.getSessionIdentity();
    const teamId = route.paramMap.get('customerId');
    if (typeof userId !== 'string' || !userId || typeof teamId !== 'string' || !teamId) {
      return this.disabledRedirect();
    }

    const evaluationIdentity = {};
    this.activeEvaluationIdentity = evaluationIdentity;
    try {
      const enabled = await this.managedFeatureFlagsService.isEnabled(
        TEAM_ADMIN_TRANSACTION_RECONCILIATION_FLAG,
        'team-admin',
        { userId, teamId },
      );
      const contextIsCurrent = this.activeEvaluationIdentity === evaluationIdentity
        && this.sessionService.getUserId() === userId
        && this.getSessionIdentity() === sessionIdentity
        && route.paramMap.get('customerId') === teamId;
      return enabled === true && contextIsCurrent ? true : this.disabledRedirect();
    } catch (_error) {
      if (this.activeEvaluationIdentity === evaluationIdentity) {
        console.error('Failed to evaluate Transaction Reconciliation access');
      }
      return this.disabledRedirect();
    }
  }

  private disabledRedirect(): UrlTree {
    return this.router.parseUrl('/teampayments');
  }

  private getSessionIdentity(): string {
    const token = this.sessionService.decodeJWTToken();
    const issuedAt = Number(token?.iat);
    const expiresAt = Number(token?.exp);
    return [
      this.sessionService.getUserId(),
      Number.isFinite(issuedAt) ? issuedAt : '',
      Number.isFinite(expiresAt) ? expiresAt : '',
    ].join('|');
  }
}
